export default __webpack_public_path__ + "static/media/car_piece_of_mind.6b96ec84.svg";